import ctiWindow from './ctiWindow'

class utilityHelper {
  static async buildFormData (formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && data.length !== 0) {
      await this.asyncForEach(Object.keys(data), async key => {
        await this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
      })
    } else {
      const value = (data === null) ? '' : data
      formData.append(parentKey, value)
    }

    Promise.resolve()
  }

  static async asyncForEach (array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  static getFileExtension (object) {
    return object.split('.').pop()
  }

  static openPopUp (popUpType, callType, params, callback = null) {
    switch (callType) {
    case 'outbound':
      ctiWindow.outboundWindow(params)
      // if (popUpType === 'window') { ctiWindow.outboundWindow(params) }
      // if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'outbound-select-member':
      ctiWindow.outboundSelectMemberWindow(params)
      // if (popUpType === 'window') { ctiWindow.outboundWindow(params) }
      // if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'edit-outbound':
      if (popUpType === 'window') { ctiWindow.editOutboundWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'edit-consultation':
      if (popUpType === 'window') { ctiWindow.editConsultationWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'view-consultation':
      ctiWindow.viewConsultationWindow(params)
      break
    case 'inbound':
      // ctiWindow.inboundWindow(params)
      if (popUpType === 'window') { ctiWindow.inboundWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-member':
      if (popUpType === 'window') { ctiWindow.addMemberWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'outbound-history':
      ctiWindow.outboundHistoryWindow(params)
      // if (popUpType === 'window') { ctiWindow.outboundHistoryWindow(params) }
      // if (popUpType === 'dialog') { ctiWindow.outboundHistoryDialog(params) }
      break
    case 'outbound-company-list':
      if (popUpType === 'window') { ctiWindow.outboundCompanyListWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-announcement':
      if (popUpType === 'window') { ctiWindow.addAnnouncementWindow() }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'view-announcement':
      if (popUpType === 'window') { ctiWindow.viewAnnouncementWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'consultation-add-custom-field':
      if (popUpType === 'window') { ctiWindow.addConsultationCustomFieldWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'consultation-edit-custom-field':
      if (popUpType === 'window') { ctiWindow.editConsultationCustomFieldWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-user':
      if (popUpType === 'window') { ctiWindow.addUserWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'edit-user-permission':
      if (popUpType === 'window') { ctiWindow.editUserPermissionWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-project':
      if (popUpType === 'window') { ctiWindow.addProjectWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-blacklist':
      if (popUpType === 'window') { ctiWindow.addBlacklistWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'edit-project':
      if (popUpType === 'window') { ctiWindow.editProjectWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-task':
      if (popUpType === 'window') { ctiWindow.addTaskWindow() }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'edit-task':
      if (popUpType === 'window') { ctiWindow.editTaskWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'view-task':
      if (popUpType === 'window') { ctiWindow.viewTaskWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'edit-task-progress':
      if (popUpType === 'window') { ctiWindow.editTaskProgressWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-message-template':
      if (popUpType === 'window') { ctiWindow.addMessageTemplateWindow() }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'edit-message-template':
      if (popUpType === 'window') { ctiWindow.editMessageTemplateWindow(params.data) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params.data) } }
      break
    case 'send-sms':
      if (popUpType === 'window') { ctiWindow.openSendSMSWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params.number) } }
      break
    case 'edit-callback-number': // TODO: Remove this
      if (popUpType === 'window') { ctiWindow.openEditCallbackNumberWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params.id) } }
      break
    case 'add-messages-category':
      if (popUpType === 'window') { ctiWindow.addMessageCategoryWindow() }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'edit-time-condition':
      if (popUpType === 'window') { ctiWindow.openEditTimeConditionWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params) } }
      break
    case 'add-time-condition':
      if (popUpType === 'window') { ctiWindow.openAddTimeConditionWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'edit-announcement':
      if (popUpType === 'window') { ctiWindow.openEditAnnouncementWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params.id) } }
      break
    case 'edit-transfer':
      if (popUpType === 'window') { ctiWindow.openEditTransferWindow(params) }
      if (popUpType === 'dialog') { if (callback !== null) { callback(params.id) } }
      break
    case 'transfer-history':
      if (popUpType === 'window') { ctiWindow.openTransfersHistorWindow() }
      if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'send-message':
      ctiWindow.openSendMessageWindow()
      // if (popUpType === 'window') { ctiWindow.openSendMessageWindow() }
      // if (popUpType === 'dialog') { if (callback !== null) { callback() } }
      break
    case 'outbound-popup':
      ctiWindow.openOutboundPopupWindow(params)
      break
    case 'update-schedule':
      ctiWindow.openUpdateSchedulePopupWindow(params)
      break
    case 'view-schedule':
      ctiWindow.viewScheduleWindow(params)
      break
    case 'add-sound-file':
      ctiWindow.openUploadSoundFileWindow()
      break
    case 'open-sound-files':
      ctiWindow.openSoundFileWindow(params.extension)
      break
    case 'upload-auto-call-system-public-data':
      ctiWindow.openUploadAutoCallSystemPublicDataWindow()
      break
    case 'export-auto-call-system-public-data':
      ctiWindow.openExportAutoCallSystemPublicDataWindow()
      break
    case 'delete-auto-call-system-public-data':
      ctiWindow.openDeleteAutoCallSystemPublicDataWindow()
      break
    case 'upload-auto-call-system-data':
      ctiWindow.openUploadAutoCallSystemDataWindow()
      break
    case 'export-auto-call-system-data':
      ctiWindow.openExportAutoCallSystemDataWindow()
      break
    case 'delete-auto-call-system-data':
      ctiWindow.openDeleteAutoCallSystemDataWindow()
      break
    case 'edit-caller-id':
      ctiWindow.openEditCallerIdWindow(params)
      break
    case 'edit-company-worktime':
      ctiWindow.openEditCompanyWorktimeWindow()
      break
    case 'view-extension-status-data-analysis':
      ctiWindow.openViewExtensionStatusDataAnalysisPopupWindow(params)
      break
    case 'time-condition-sound-file':
      ctiWindow.openTimeConditionSoundFileWindow(params.index, params.list)
      break
    case 'modify-queue':
      ctiWindow.openModifyQueueWindow(params.index, params.list)
      break
    }

  }
}

export default utilityHelper
